import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {DetailsPageWrapper} from '@/components/ui/details-atoms/DetailsAtoms'
import {AlertCircleIcon, AlertTriangleIcon} from '@/components/ui/icon/Icon'
import {Spinner} from '@/components/ui/spinner/Spinner'
import {useGetPatient} from '@/features/patients/services/useGetPatient'
import {PatientDetailsUrlParams} from '@/features/patients/types'
import {useURLParsedParams} from '@/hooks/useURLParsedParams'
import {useTranslation} from '@/translations/i18n'
import {resolveResourceForbiddenErrorLabel} from '@/utilities/helpers'
import {AxiosError} from 'axios'
import {Outlet} from 'react-router-dom'

export const PatientDetailsRoute = () => {
    const {t} = useTranslation()
    const urlParams = useURLParsedParams(PatientDetailsUrlParams)
    const patientQuery = useGetPatient({
        patientId: urlParams.success ? urlParams.data.id : undefined,
        responseType: 'extended',
        options: {
            enabled: !!urlParams.success
        }
    })

    // renders
    if (patientQuery.isPending) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <Spinner size={32} style={{placeSelf: 'center'}} />
            </DetailsPageWrapper>
        )
    }

    if (
        !urlParams.success ||
        (patientQuery.error instanceof AxiosError && patientQuery.error.response?.status == 404)
    ) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:invalid_link')} />
            </DetailsPageWrapper>
        )
    }

    const forbiddenErrorLabel = resolveResourceForbiddenErrorLabel(patientQuery.error)
    if (forbiddenErrorLabel) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <NoPermissionBox title={t(forbiddenErrorLabel)} />
            </DetailsPageWrapper>
        )
    }

    if (patientQuery.error) {
        return (
            <DetailsPageWrapper isSuccess={false}>
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            </DetailsPageWrapper>
        )
    }

    return urlParams.success ? (
        <Outlet context={{patient: patientQuery.data}} />
    ) : (
        <ErrorBox title={t('errors:invalid_link')} icon={<AlertTriangleIcon />} />
    )
}
